/* IntelApps — Stats Band */
import React from 'react';
import { useI18n } from '../i18n.js';

export default function StatsBand() {
  const { t } = useI18n();

  return (
    <section className="section" style={{ paddingTop: 0 }}>
      <div className="stats">
        <div className="stats-head">
          <span className="eyebrow">{t.stats.eyebrow}</span>
          <h3>{t.stats.title}</h3>
        </div>
        <div>
          <div className="stat-num">
            {t.stats.launches.num}
            <span className="accent">{t.stats.launches.unit}</span>
          </div>
          <div className="stat-label">
            {t.stats.launches.label}
            <br />
            {t.stats.launches.sublabel}
          </div>
        </div>
        <div>
          <div className="stat-num">
            {t.stats.revenue.num}
            <span className="accent">{t.stats.revenue.unit}</span>
          </div>
          <div className="stat-label">
            {t.stats.revenue.label}
            <br />
            {t.stats.revenue.sublabel}
          </div>
        </div>
        <div>
          <div className="stat-num">
            {t.stats.delivery.num}
            <span className="accent">{t.stats.delivery.unit}</span>
          </div>
          <div className="stat-label">
            {t.stats.delivery.label}
            <br />
            {t.stats.delivery.sublabel}
          </div>
        </div>
      </div>
    </section>
  );
}
